import { render, staticRenderFns } from "./BaseTruncatedField.vue?vue&type=template&id=2fe80c62&"
import script from "./BaseTruncatedField.vue?vue&type=script&lang=js&"
export * from "./BaseTruncatedField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports